import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import "./css/empowerinvestment.css";

export default function EmpowerInvestment() {
  const navigate = useNavigate();
  // const loginDetails = useSelector((state) => state.auth.LoginDetails);

  const infiApplicationForm = () => {
    navigate(`${config.baseUrl}infiListingForm`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="EmpowerInvestment position-relative pt-5 pb-0">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center pt-lg-3 mt-5">
            <Col lg={12}>
              <div className="cardStyle2">
                <Card className="cardBox overflow-hidden">
                  <div className="leftplate position-absolute start-0">
                    <img src="images/shape/leftplate.png" />
                  </div>
                  <Card.Body>
                    <div className="text-center pt-5 pb-5 position-relative">
                      <h1 className="text-white lh-sm mb-4">
                        Amplify Your Crypto Project with <br />
                        <span className="text-primary2 text-uppercase">
                          Paid Promotions!
                        </span>
                      </h1>
                      <Button
                        as={Link}
                        to={`${config.baseUrl}promote`}
                        variant="default"
                        className="btn-white-gradient text-black rounded-5 fw-bold position-relative z-2 px-4"
                      >
                        Promote Your Project Today&nbsp;&nbsp;&nbsp;
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="16"
                          viewBox="0 0 24 19"
                          fill="none"
                        >
                          <path
                            d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>
                    </div>
                  </Card.Body>
                  <div className="rightplate position-absolute end-0">
                    <img src="images/shape/rightplate.png" />
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
